import { render, staticRenderFns } from "./points_balance.vue?vue&type=template&id=2e44f75e"
import script from "./points_balance.vue?vue&type=script&lang=js"
export * from "./points_balance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports